import {
  SET_LLM_CONFIG,
  SET_LLM_CONFIG_LOADING,
  SET_LLM_CONFIG_ERROR,
  SET_LLM_VALIDATION_RESULT,
  SET_LLM_RATE_LIMIT,
  SET_LLM_CHAT_LOADING,
} from '../actions/llmProviders.actions';

const initialState = {
  config: null,
  loading: false,
  error: null,
  validationResult: {
    loading: false,
    valid: null,
    message: null,
  },
  rateLimit: {
    messagesUsed: 0,
    messagesLimit: 0,
    isLimited: false,
    resetsAt: null,
  },
  chatLoading: false,
};

const llmProvidersReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_LLM_CONFIG: {
      return {
        ...state,
        config: action.payload,
        error: null,
      };
    }
    case SET_LLM_CONFIG_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case SET_LLM_CONFIG_ERROR: {
      return {
        ...state,
        error: action.payload,
      };
    }
    case SET_LLM_VALIDATION_RESULT: {
      return {
        ...state,
        validationResult: action.payload,
      };
    }
    case SET_LLM_RATE_LIMIT: {
      return {
        ...state,
        rateLimit: action.payload,
      };
    }
    case SET_LLM_CHAT_LOADING: {
      return {
        ...state,
        chatLoading: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default llmProvidersReducer;
